// extracted by mini-css-extract-plugin
var _1 = "gSR00";
var _2 = "OcrP8";
var _3 = "jQdnZ";
var _4 = "Zrrv7";
var _5 = "T8FiY";
var _6 = "r_B4e";
export { _1 as "base", _2 as "dropZone", _3 as "isDragOver", _4 as "mask", _5 as "messageBlock", _6 as "uploadIcon" }
